import { render } from "./factoryTrack.vue?vue&type=template&id=2c1ac63c&scoped=true"
import script from "./factoryTrack.vue?vue&type=script&lang=js"
export * from "./factoryTrack.vue?vue&type=script&lang=js"

import "./factoryTrack.vue?vue&type=style&index=0&id=2c1ac63c&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1ac63c"]])

export default __exports__